/// lower case and add a capital letter to the first letter of each sentence

module.exports = function () {
    return function (paragraph) {
        if (paragraph && paragraph.length > 0 && typeof paragraph === 'string') {
            return paragraph.replace(/.+?[\.\?\!](\s|$)/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        }

        return paragraph;
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/filters/oly-apply-sentence-case.js
 **/